import React, { Component } from "react";
import history from "../../login/history";
import { trackPromise, promiseTrackerHoc } from "react-promise-tracker";
import Popup from "react-popup";
import Select from "react-select";
import SubsidiosService from "../../../../services/solicitudes/SubsidiosService";
import CampoFecha from "../../../generico/Fecha";
import $ from "jquery";
import SelectComponente from "../../../generico/SelectComponente";
import {FontAwesomeIcon}  from "@fortawesome/react-fontawesome";
import {faArrowLeft, faArrowRight} from "@fortawesome/free-solid-svg-icons";

export default class AgregarSubsidioPaso2 extends Component {
  constructor(props) {
    super(props);
    this.state = this.getInitialState();
  }

  notifiPopup = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
            },
          },
        ],
      },
    });

  getInitialState = () => ({
    sexoOptions: [
      { value: "F", label: "Femenino" },
      { value: "M", label: "Masculino" },
    ],
    nacionalidadOptions: [],
    nacDescripcion: undefined,
    primerNombreCon: undefined,
    segundoNombreCon: undefined,
    primerApellidoCon: undefined,
    segundoApellidoCon: undefined,
    cedulaCon: undefined,
    fechaNacimientoCon: undefined,
    nroNacionalidadCon: undefined,
    disableSgte: true
  });

  componentDidMount() {
    this.getNacionalidades();
  }

  /******************
   * HANDLE CHANGES *
   ******************/

   handleValidateFocus = () => {
    this.validarCampos()
  }

  handleChangePrimerNombre = (e) => {
    if (e.target.value.trim() === "") {
      this.setState({ primerNombreCon: undefined, disableSgte: true }, () => {
        this.handleValidacion();
      });
      return;
    }
    this.setState({ primerNombreCon: e.target.value }, () => {
      this.handleValidacion();
    });
  };

  handleChangeSegundoNombre = (e) => {
    if (e.target.value.trim() === "") return;
    this.setState({ segundoNombreCon: e.target.value });
  };

  handleChangePrimerApellido = (e) => {
    if (e.target.value.trim() === "") {
      this.setState({ primerApellidoCon: undefined, disableSgte: true }, () => {
        this.handleValidacion();
      });
      return;
    }
    this.setState({ primerApellidoCon: e.target.value }, () => {
      this.handleValidacion();
    });
  };

  handleChangeSegundoApellido = (e) => {
    if (e.target.value.trim() === "") return;
    this.setState({ segundoApellidoCon: e.target.value });
  };

  handleChangeDate = (dataDate) => {
    this.setState({ fechaNacimientoCon: dataDate }, () => {
      this.handleValidacion();
    });
  };

  handleChangeCedula = (e) => {
    let nroCI = e.target.value = e.target.value.replace("\\D+", e.target.value.slice(0, e.target.value.lenght -1));
    if (nroCI.trim() === "") {
      this.setState({ cedulaCon: undefined, disableSgte: true }, () => {
        this.handleValidacion();
      });
      return;
    }
    this.setState({ cedulaCon: nroCI }, () => {
      this.handleValidacion();
    });
  };

  /***********************
   * HANDLE VALIDACIONES *
   ***********************/

  handleValidacion = () => {
    if (
      this.state.primerNombreCon &&
      this.state.primerApellidoCon &&
      this.state.cedulaCon &&
      this.state.fechaNacimientoCon &&
      this.state.nroNacionalidadCon
    )
      this.setState({ disableSgte: false });
      else {
        this.setState({ disableSgte: true }, () => {});
      }
  };

  validarCampos = () => {
    $("#idFormConyuge").validate({
      onfocusout: function (element) {
        $(element).valid();
      },
      rules: {
        primerNombre: "required",
        primerApellido: "required",
        "cedula-conyuge": "required",
      },
      messages: {
        primerNombre: "Este campo es requerido",
        primerApellido: "Este campo es requerido",
        "cedula-conyuge": "Este campo es requerido",
      },
      errorElement: "span",
      errorPlacement: function (error, element) {
        error.addClass("invalid-feedback");
        element.addClass("is-invalid");
        element.closest(".form-group").append(error);
      },
      unhighlight: function (element, errorClass, validClass) {
        $(element).removeClass("is-invalid");
      },
    });
  };

  /**************************
   * OBTENER NACIONALIDADES *
   **************************/

  getNacionalidades() {
    var options = [];
    trackPromise(
      SubsidiosService.obtenerNacionalidades().then((response) => {
        var data = JSON.stringify(response.data);
        //console.log("datos", data)
        var jsonData = JSON.parse(data);
        if (jsonData.codigo === 0) {
          for (var i = 0; i < jsonData.datos.length; i++) {
            options.push({
              value: jsonData.datos[i].numero,
              label: jsonData.datos[i].descripcion,
            });
          }
          this.setState({ nacionalidadOptions: options });
        } else {
          Popup.queue(this.notifiPopup("Error", jsonData.mensaje));
          return;
        }
      })
    );
    return options;
  }

  loadNacionalidades = () => {
    if (this.state.nacionalidadOptions !== undefined) {
      return this.state.nacionalidadOptions;
    } else {
      return this.getNacionalidades();
    }
  };

  selectorValueNac = (dataFromChild, item) => {
    console.log(dataFromChild);
    if (dataFromChild === undefined) {
      this.setState({
        nroNacionalidad: undefined,
      });
      return;
    }
    this.setState({
      nroNacionalidadCon: dataFromChild,
      nacDescripcion: item.label,
    }, () => {this.handleValidacion()});
  };

  /******************************************
   * CONTINUAR -> CARGA DATOS A SUBSIDIO.JS *
   ******************************************/
  volverSubsidios = () => {
    this.props.respuestasData.claseSubsidio === 2
      ? this.props.goToStep(3)
      : this.props.goToStep(1);
  };

  continuar = () => {
    console.log(this.state.nroNacionalidadCon)
    this.props.respuestaPaso2c(
      this.state.primerNombreCon,
      this.state.segundoNombreCon,
      this.state.primerApellidoCon,
      this.state.segundoApellidoCon,
      this.state.cedulaCon,
      this.state.fechaNacimientoCon,
      this.state.nroNacionalidadCon,
      this.state.nacDescripcion
    );
    this.nextStep.click();
  };

  preventDefault = (e) => {
    e.preventDefault();
  };

  render() {

    let nacionalidades = this.loadNacionalidades();
    return (
      <div>
        <div className="row">
          <div className="steps clearfix steps-doc">
            <ul role="tablist">
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
               
                    <span className="title_text">Selección de Cuenta</span>
                  </div>
                </span>
              </li>
              {this.props.respuestasData.claseSubsidio === 2 && (
                <li role="tab" className="disabled">
                  <span>
                    <div className="title">
                      
                      <span className="title_text">Recién Nacido</span>
                    </div>
                  </span>
                </li>
              )}
              <li role="tab" className="current">
                <span>
                  <div className="title">
                    
                    <span className="title_text current">Datos Cónyuge</span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                   
                    <span className="title_text">Adjuntar Documentos</span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    
                    <span className="title_text">Datos de Verificación</span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    
                    <span className="title_text">Confirmación</span>
                  </div>
                </span>
              </li>
            </ul>
          </div>
        </div>
        <form id="idFormConyuge" onSubmit={this.preventDefault}>
          <div className="row justify-content-md-center">
            <div className="col-md-10">
              <div className="row">
                <div className="col-md-10">
                  <br />
                  <h5 className="card-subtitle">Datos del Cónyuge</h5>
                  <br />
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="row justify-content-md-center">
                    <div className="col-lg-6 col-md-6">
                      <div className="form-group">
                        <label
                          className="input-label-bold"
                          htmlFor="primer-nombre-conyuge"
                        >
                          Primer Nombre *
                        </label>
                        <input
                          type="text"
                          name="primerNombre"
                          id="primer-nombre-conyuge"
                          placeholder="Ingresar primer nombre"
                          className="form-control input-box"
                          onChange={this.handleChangePrimerNombre}
                          onFocus={this.handleValidateFocus}
                        />
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6">
                      <div className="form-group">
                        <label
                          className="input-label-bold"
                          htmlFor="segundo-nombre-conyuge"
                        >
                          Segundo Nombre
                        </label>
                        <input
                          type="text"
                          id="segundo-nombre-conyuge"
                          placeholder="Ingresar segundo nombre"
                          className="form-control input-box"
                          onBlur={this.handleChangeSegundoNombre}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="row justify-content-md-center">
                    <div className="col-lg-6 col-md-6">
                      <div className="form-group">
                        <label
                          className="input-label-bold"
                          htmlFor="primer-apellido-conyuge"
                        >
                          Primer Apellido *
                        </label>
                        <input
                          type="text"
                          name="primerApellido"
                          id="primer-apellido-conyuge"
                          placeholder="Ingresar primer apellido"
                          className="form-control input-box"
                          onChange={this.handleChangePrimerApellido}
                        />
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6">
                      <div className="form-group">
                        <label
                          className="input-label-bold"
                          htmlFor="segundo-apellido-conyuge"
                        >
                          Segundo Apellido
                        </label>
                        <input
                          type="text"
                          id="segundo-apellido-conyuge"
                          placeholder="Ingresar segundo apellido"
                          className="form-control input-box"
                          onBlur={this.handleChangeSegundoApellido}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="row justify-content-md-center">
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label
                          className="input-label-bold"
                          htmlFor="cedula-conyuge"
                        >
                          Cédula *
                        </label>
                        <input
                          type="number"
                          name="cedula-conyuge"
                          min={1}
                          placeholder="Ingrese número de cédula"
                          className="input-box form-control"
                          onChange={(e) => this.handleChangeCedula(e)}
                        />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label
                          className="input-label-bold"
                          htmlFor="fecha-nacimiento-conyuge"
                        >
                          Fecha de Nacimiento *
                        </label>
                        <CampoFecha
                          id="fecha-nacimiento-conyuge"
                          name="fechaNacimiento"
                          placeholder={"Ingresar fecha de nacimiento"}
                          onChange={this.handleChangeDate}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="row justify-content-md-center">
                    <div className="col-md-12">
                      {
                        <SelectComponente
                          id="nacionalidad"
                          titulo="Nacionalidad"
                          presentacion="SELECT"
                          selectorValue={this.selectorValueNac.bind(this)}
                          itemSelected={this.state.nroNacionalidad}
                          options={nacionalidades}
                          addInvalid={true}
                        />
                      }
                    </div>
                  </div>
                </div>
              </div>
              <hr />
              <div className="row">
                <div className="col-md-12">
                  <div className="row">
                    <div className="col-md-6">
                      <label className="input-label-bold-obligatorio float-left">
                        (*) Campos Obligatorios
                      </label>
                    </div>
                    <div className="col-md-3">
                          <button
                      className="btn btn-cu-quintary btn-consulta"
                      onClick={this.volverSubsidios}
                    >
                    <FontAwesomeIcon icon={faArrowLeft} />  Volver
                    </button>
                    </div>
                    <div className="col-md-3">
                    <button
                disabled={this.state.disableSgte}
                className="btn btn-cu-primary"
                onClick={() => {
                  this.continuar();
                }}
              >
                Continuar <FontAwesomeIcon icon={faArrowRight} />
              </button>
              <button
                hidden
                ref={(a) => (this.nextStep = a)}
                className="btn btn-cu-primary"
                onClick={this.props.nextStep}
              ></button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  }
}
